import { render } from "./ArgumentNewItem.vue?vue&type=template&id=53b838c1"
import script from "./ArgumentNewItem.vue?vue&type=script&lang=js"
export * from "./ArgumentNewItem.vue?vue&type=script&lang=js"

import "./ArgumentNewItem.vue?vue&type=style&index=0&id=53b838c1&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__